import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import { ReactComponent as CheckedIcon } from '../../assets/checked.svg';
import { ReactComponent as ShareSaveIcon } from '../../assets/share-save.svg';
import { ReactComponent as ShareTgIcon } from '../../assets/share-tg.svg';
import { ReactComponent as ShareVkIcon } from '../../assets/share-vk.svg';
import './style.scss';

const SuccessScreen = (props) => {
    const { schedule } = props;
    const { screens, settings } = schedule;

    const date = screens.success.data ? moment(screens.success.data.date_write).format('dddd, DD.MM.YYYY') : '';
    const time = screens.success.data ? `${moment(screens.success.data.time_start).format('HH:mm')}-${moment(screens.success.data.time_end).format('HH:mm')}` : '';
    const title = screens.success.data ? screens.success.data.success_message.title : ' ';
    const text = screens.success.data ? screens.success.data.success_message.text.replace('%date_write%', `${date} ${time}`) : ' ';
    const pdf = screens.success.data ? screens.success.data.pdf : '';

    // const test = {
    //     title: 'Забронировано!',
    //     text: 'Талон забронирован на среда, 22.11.2023 07:40 наш менеджер свяжется с Вами для подтверждения записи.',
    //     pdf: 'http://vpriem.local/pdfs/write-390-21-11-2023-14-23-24.pdf'
    // };

    return (
        <div className="screen success">
            <div className="screen_icon">
                <CheckedIcon />
            </div>
            <p className="screen_title" dangerouslySetInnerHTML={{ __html: title }} />
            <p className="screen_desc" dangerouslySetInnerHTML={{ __html: text }} />
            <div className="screen__share share">
                <span>Сохранить талон:</span>
                <div className="share__items">
                    <a href={pdf} download className="share__item">
                        <ShareSaveIcon />
                        <span>Сохранить на устройство</span>
                    </a>
                    <a href={`https://vk.com/share.php?url=${pdf}`} target="_blank" rel="noreferrer" className="share__item">
                        <ShareVkIcon />
                        <span>Отправить в VK</span>
                    </a>
                    <a href={`https://telegram.me/share/url?url=${pdf}&text=Талон на приём`} target="_blank" rel="noreferrer" className="share__item">
                        <ShareTgIcon />
                        <span>Отправить в Telegram</span>
                    </a>
                </div>
            </div>
            {settings.notify_write_bot ? (
                <div className="screen__notify notify">
                    <span>Уведомления</span>
                    <p>Подпишитесь на бота, чтобы получать уведомления о записи в VK. Просто напишите <a href="https://vk.com/im?sel=-223583302">нашему боту</a>.</p>
                </div>
            ) : null}
        </div>
    );
};

SuccessScreen.propTypes = {
    schedule: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    schedule: state.schedule
});


export default connect(mapStateToProps)(SuccessScreen);
